import { getCurrentOrganization } from "@ckweb/ckfetch/connectables/organization";
import { getIndustryLookupList } from "@ckweb/ckfetch/connectables/setup";

export function useGetIndustries() {
  return useSafeLocalFetch("getIndustryLookupList", getIndustryLookupList, {
    fallback: [],
    customFetchOpts: {
      allowAnonymous: true,
      beforeRequest: async (request) => {
        request.headers.append("Authorization", "");
      },
    },
  });
}

export function useGetCurrentOrganization() {
  return useSafeLocalFetch("getCurrentOrganization", getCurrentOrganization, {
    fallback: (organization) => organization as OrganizationInfo | undefined,
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });
}
